<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-md-12 text-center">
        <h1 class="display-1">404</h1>
        <p class="lead">Page non trouvée</p>
        <p>La page que vous recherchez n'existe pas ou a été déplacée.</p>
        <router-link to="/" class="btn btn-primary"
          >Retour à l'accueil</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
  }
</script>

<style>
  /* Vous pouvez ajouter des styles supplémentaires ici si nécessaire */
</style>
